export function cropString(text: string, step = 4) {
  if (text.length > 20) {
    const head = text.substring(0, step);
    const tail = text.substring(text.length - step, text.length);
    return `${head}...${tail}`;
  }
  return text;
}
